import { Routes, Route, Navigate } from 'react-router-dom';
import Index from '@/pages/Index';
import Chat from '@/pages/Chat';
// History page removed - functionality integrated into Chat
import Profile from '@/pages/Profile';
import Onboarding from '@/pages/Onboarding';
import Alerts from '@/pages/Alerts';
import MarketScreener from '@/pages/MarketScreener';
import StrykrDashboard from '@/pages/StrykrDashboard';
import Pricing from '@/pages/Pricing';
import WalletAnalyzer from '@/pages/WalletAnalyzer';
import { Auth } from '@/pages/Auth';
import { AuthCallback } from '@/components/auth/AuthCallback';
import { ResetPassword } from '@/pages/ResetPassword';
import { SidebarProvider } from '@/components/ui/sidebar';
import { AppLayout } from '@/components/layouts/AppLayout';
import { PrivateRoute } from '@/components/auth/PrivateRoute';
import { AdminRoute } from '@/components/auth/AdminRoute';
import Developer from '@/pages/Developer';
import ApiKeys from '@/pages/Developer/ApiKeys';

export const AppRoutes = () => {
	return (
		<SidebarProvider>
			<Routes>
				{/* Public routes - no authentication required */}
				<Route path="/auth/*" element={<Auth />} />
				<Route path="/auth/callback" element={<AuthCallback />} />
				<Route path="/reset-password" element={<ResetPassword />} />
				<Route path="/pricing" element={<Pricing />} />
				<Route path="/wallet-analyzer" element={<WalletAnalyzer />} />

				{/* Protected routes - require authentication */}
				<Route
					path="/onboarding"
					element={
						<PrivateRoute>
							<Onboarding />
						</PrivateRoute>
					}
				/>
				{/* Root path redirects to dashboard for better analytics tracking */}
				<Route path="/" element={<Navigate to="/dashboard" replace />} />
				<Route
					path="/dashboard"
					element={
						<PrivateRoute>
							<AppLayout>
								<StrykrDashboard />
							</AppLayout>
						</PrivateRoute>
					}
				/>
				<Route
					path="/calendar"
					element={
						<PrivateRoute>
							<AppLayout>
								<Index />
							</AppLayout>
						</PrivateRoute>
					}
				/>
				<Route
					path="/chat"
					element={
						<PrivateRoute>
							<AppLayout>
								<Chat />
							</AppLayout>
						</PrivateRoute>
					}
				/>
				<Route
					path="/profile"
					element={
						<PrivateRoute>
							<AppLayout>
								<Profile />
							</AppLayout>
						</PrivateRoute>
					}
				/>
				<Route
					path="/alerts"
					element={
						<PrivateRoute>
							<AppLayout>
								<Alerts />
							</AppLayout>
						</PrivateRoute>
					}
				/>

				<Route
					path="/market-screener"
					element={
						<PrivateRoute>
							<AppLayout>
								<MarketScreener />
							</AppLayout>
						</PrivateRoute>
					}
				/>

				{/* Developer routes */}
				{ process.env.NODE_ENV === 'development' && (
					<Route
						path="/developer"
						element={
							<PrivateRoute>
							<AppLayout>
								<Developer />
							</AppLayout>
						</PrivateRoute>
					}
					></Route>
				)}
			</Routes>
		</SidebarProvider>
	);
};
